import { HttpAdapter } from "../../main/adapters/HttpAdapter";

export class Cnae {
    baseUrl = `${publicSettings.aws.baseUrls.dataBenchmarking}/cnae`;
    constructor() {
        this.HttpAdapter = new HttpAdapter();
    }

    async search(term) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrl}/search`,
                { term }
            );
            return response;
        } catch (error) {
            throw new Error(error?.message || "Erro ao buscar CNAE");
        }
    }
}
